export const blockIconsMapsLayers = (
	<span className='material-symbols-outlined'>layers</span>
);
